export const fall_2026_3200_calendar = [
/***WEEK 1***/
{
    weekNumber: 1,
    entries: [
        {
            date: "August 17 (Monday) / August 18 (Tuesday)",
            topic: "",
            items: [
                "First day of class",
                    "Statements and logical connectives",
            ]
        },
        {
            date: "August 19 (Wednesday) / August 20 (Thursday)",
            topic: "",
            items: [
                "Compound statements, truth tables, implications",
                    "Homework 1 due 8/27"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 2***/
{
    weekNumber: 2,
    entries: [
        {
            date: "August 24 (Monday) / August 25 (Tuesday)",
            topic: "",
            items: ["Qualifiers and negations"]
        },
        {
            date: "August 26 (Wednesday) / August 27 (Thursday)",
            topic: "",
            items: [
                "Some approaches to proof, parity proofs",
                    "Homework 2 due 9/3"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 3***/
{
    weekNumber: 3,
    entries: [
        {
            date: "August 31 (Monday) / September 1 (Tuesday)",
            topic: "",
            items: ["Divisibility proofs",]
        },
        {
            date: "September 2 (Wednesday) / September 3 (Thursday)",
            topic: "",
            items: [
                "More examples of proofs",
                    "Homework 3 due 9/10"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 4***/
{
    weekNumber: 4,
    entries: [
        {
            date: "September 7 (Monday) / September 8 (Tuesday)",
            topic: "",
            items: [
                 "Begin induction",
            ]
        },
        {
            date: "September 9 (Wednesday) / September 10 (Thursday)",
            topic: "",
            items: [
                "Induction examples, begin strong induction",
                    "Homework 4 due 9/17"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 5***/
{
    weekNumber: 5,
    entries: [
        {
            date: "September 14 (Monday) / September 15 (Tuesday)",
            topic: "",
            items: ["Strong induction"]
        },
        {
            date: "September 16 (Wednesday) / September 17 (Thursday)",
            topic: "",
            items: ["Finish induction",
                    "Homework 5 due 9/28"]
        },
    ]
},
/***END WEEK***/

/***WEEK 6***/
{
    weekNumber: 6,
    entries: [
        {
            date: "September 21 (Monday) / September 22 (Tuesday)",
            topic: "",
            items: [
                "Exam 1 (Tuesday)"
            ]
        },
        {
            date: "September 23 (Wednesday) / September 24 (Thursday)",
            topic: "",
            items: [
                "Exam 1 (Wednesday)"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 7***/
{
    weekNumber: 7,
    entries: [
        {
            date: "September 28 (Monday) / September 29 (Tuesday)",
            topic: "",
            items: [
                "Begin sets",
                "Homework 6 (due 10/2)"
            ]
        },
        {
            date: "September 30 (Wednesday) / October 1 (Thursday)",
            topic: "",
            items: ["Subsets; unions and intersections",
                "Homework 7 (due 10/8)"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 8***/
{
    weekNumber: 8,
    entries: [
        {
            date: "October 5 (Monday) / October 6 (Tuesday)",
            topic: "",
            items: ["More definitions, practice with element chasing, set products"]
        },
        {
            date: "October 7 (Wednesday) / October 8 (Thursday)",
            topic: "",
            items: ["Power sets",
                "Homework 8 (due 10/15)"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 9***/
{
    weekNumber: 9,
    entries: [
        {
            date: "October 12 (Monday) / October 13 (Tuesday)",
            topic: "",
            items: ["Index sets"]
        },
        {
            date: "October 14 (Wednesday) / October 15 (Thursday)",
            topic: "",
            items: ["Begin relations",
                "Homework 9 (due 10/22)"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 10***/
{
    weekNumber: 10,
    entries: [
        {
            date: "October 19 (Monday) / October 20 (Tuesday)",
            topic: "",
            items: ["More on relations"]
        },
        {
            date: "October 21 (Wednesday) / October 22 (Thursday)",
            topic: "",
            items: ["Equivalence relations",
                "Homework 10 (due 10/29)"
            ]
        },
    ]
},
/***END WEEK***/

/***WEEK 11***/
{
    weekNumber: 11,
    entries: [
        {
            date: "October 26 (Monday) / October 27 (Tuesday)",
            topic: "",
            items: ["Begin functions"]
        },
        {
            date: "October 28 (Wednesday) / October 29 (Thursday)",
            topic: "",
            items: ["Injective and surjective functions"]
        },
    ]
},
/***END WEEK***/

/***WEEK 12***/
{
    weekNumber: 12,
    entries: [
        {
            date: "November 2 (Monday) / November 3 (Tuesday)",
            topic: "",
            items: ["Exam 2"]
        },
        {
            date: "November 4 (Wednesday) / November 5 (Thursday)",
            topic: "",
            items: []
        },
    ]
},
/***END WEEK***/

/***WEEK 13***/
{
    weekNumber: 13,
    entries: [
        {
            date: "November 9 (Monday) / November 10 (Tuesday)",
            topic: "",
            items: [""]
        },
        {
            date: "November 11 (Wednesday) / November 12 (Thursday)",
            topic: "",
            items: []
        },
    ]
},
/***END WEEK***/

/***WEEK 14***/
{
    weekNumber: 14,
    entries: [
        {
            date: "November 16 (Monday) / November 17 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "November 18 (Wednesday) / November 19 (Thursday)",
            topic: "",
            items: []
        },
    ]
},
/***END WEEK***/

/***WEEK 15***/
{
    weekNumber: 15,
    entries: [
        {
            date: "November 23 (Monday) / November 24 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "November 25 (Wednesday) / November 26 (Thursday)",
            topic: "",
            items: []
        },
    ]
},
/***END WEEK***/

/***WEEK 16***/
{
    weekNumber: 16,
    entries: [
        {
            date: "November 30 (Monday) / December 1 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "December 2 (Wednesday) / December 3 (Thursday)",
            topic: "",
            items: []
        },
    ]
},
/***END WEEK***/

];


// WEBPACK FOOTER //
// ./src/data/calendars/fall_2026_3200_calendar.js